import {stringify} from 'qs'
import request from 'utils/request'
import api from 'common/api/store'
import {format} from 'utils'

export async function groups() {
    return request(api.groups.url)
}

export async function allStores() {
    return request(api.allStores.url)
}

export async function stores(params) {
    return request(`${api.stores.url}${stringify(params, {addQueryPrefix: true})}`)
}

export async function getGroupList(params) {
    return request(`${api.getGroupList.url}?${stringify(params)}`)
}

export async function saveGroup(params = {}) {
    return request(api.saveGroup.url, {
        method: api.saveGroup.type,
        body: params.body,
    })
}
export async function editGroup(params) {
    return request(format(api.editGroup.url, {id: params.id}), {
        method: api.editGroup.type,
        body: params.body,
    })
}

export async function delGroup(params) {
    return request(format(api.delGroup.url, {id: params.id}), {
        method: api.delGroup.type,
    })
}
